import React from "react";
import { Title } from "../Title";
import { Span } from "../Span";
import styled from "styled-components";
import { Flex } from "../Flex";
import { mediaQueries } from "../../theme";
import { Grid } from "../Grid";
import { BasicNotificationBanner } from "../BasicNotificationBanner";
import { Button } from "../Button";
import { useHistory } from "react-router-dom";
import { useUserAuthentication } from "../../contexts/UserAuthenticationProvider/UserAuthenticationProvider";
import { List } from "../List";
import { ListItem } from "../ListItem";

const GridWrapper = styled(Grid)`
  display: flex;
  flex-direction: column;

  ${mediaQueries.largeDevice} {
    display: grid;
    grid-template-columns: 30vw auto 15vw;
  }
`;

const FlexWrapper = styled(Flex)`
  ${mediaQueries.largeDevice} {
    grid-column-start: 2;
  }
`;


const NavPlaceholderFlexWrapper = styled(Flex)`
  display: none;
  ${mediaQueries.largeDevice} {
    display: flex;
  }
`;

export const DisconnectionInfo: React.FC = () => {
  const history = useHistory();

  const {
    authenticatedUserContext: { isLoggedIn },
  } = useUserAuthentication();

  const handleNextClick = () => {
    history.push(isLoggedIn ? "/disconnection" : "/login-option/disconnection");
  };

  const handlePrevClick = () => {
    history.push("");
  };

  return (
    <>
      <NavPlaceholderFlexWrapper
        position="fixed"
        top="5%"
        border="none"
        borderRight="2px solid"
        borderRightColor="neutrals.ln30"
        height="100%"
        width="max-content"
        minWidth="240px"
        pr={4}
      >
      </NavPlaceholderFlexWrapper>
      <GridWrapper mx={[3, 3, 4, 4, 0]}>
        <FlexWrapper flexDirection="column">
          <Title
            as="h1"
            fontSize={7}
            lineHeight={7}
            fontWeight="500"
            mb={5}
          >
            Important information before you start
          </Title>

          <BasicNotificationBanner
            title=""
            message={() => (
              <Span>
                Please note this application is for a{" "}
                <b>permanent disconnection (decommission)</b> from the Vector
                network. This cannot be reversed.
              </Span>
            )}
            icon="warning"
            variant="warning"
          />

          <Span
            display="inline-block"
            fontSize={4}
            lineHeight={4}
            fontWeight="500"
            mt={5}
            mb={5}
          >
            Important permanent disconnection (decommission) information prior
            to building demolitions.
          </Span>

          <Span
            display="inline-block"
            fontSize={2}
            lineHeight={2}
            fontWeight="500"
            mb={5}
          >
            <List>
              <ListItem>
                For your own safety, you must always have the electricity and
                gas services disconnected before you demolish or remove a
                building.
              </ListItem>
              <ListItem>
                Under no circumstances should demolition proceed until written
                clearance has been received from Vector.
              </ListItem>
              <ListItem>
                The permanent disconnection (decommission) will generally not
                remove fixed Vector owned assets such as pits, pillars or poles.
                If you would like any fixed Vector owned assets removed, please
                request a{" "}
                <Span>
                  <a href="https://vector.co.nz/our-services/electricity/changes-to-electricity-connections/permanent-changes-to-vector-equipment">
                    change to Vector equipment.
                  </a>
                </Span>
              </ListItem>
              <ListItem>
                To ensure efficient processing of your request, please submit
                one request for each electricity Installation Control Point
                (ICP).
              </ListItem>
              <ListItem>
                Please contact your electricity retailer to arrange a final
                electricity reading and meter removal. The electricity retailer
                for the property may charge you for the loss or removal of any
                metering equipment.
              </ListItem>
              <ListItem>
                If you want to make a connection in the future, you will be
                required to request a new connection, and this new connection
                may be subject to a capital contribution payment or other
                additional costs.
              </ListItem>
            </List>
          </Span>

          <BasicNotificationBanner
            title=""
            message={() => (
              <Span fontWeight={"700"}>
                Do not use this application to convert an overhead supply to an
                underground or to replace a service main. For such services,
                please call <a href="tel:+64508832867">0508 832 867</a> (0508
                VECTOR).
              </Span>
            )}
            icon="info"
            variant="default"
          />

          <Flex justifyContent="space-between" mt={7} mb={7}>
            <Button
              variant="secondary"
              alignSelf="flex-start"
              onClick={handlePrevClick}
            >
              Back
            </Button>

            <Button
              type="submit"
              alignSelf="flex-end"
              onClick={handleNextClick}
            >
              Next
            </Button>
          </Flex>
        </FlexWrapper>
      </GridWrapper>
    </>
  );
};
